import {
  generateGetInfiniteResourceKey,
  generateGetResourceKey,
  generateHttpGet,
  generateHttpPost,
} from "../../utils/fetcherUtils";

import { Params, Result } from "./typing";

export const httpGet$GetSecondaryArtworkList = generateHttpGet<Params, Result>(
  Result.parse
);

export const httpPost$GetSecondaryArtworkList = generateHttpPost<
  Params,
  Result
>(Result.parse);

export const getResourceKey$GetSecondaryArtworkList =
  generateGetResourceKey<Params>(["5e3a290f-ec14-4f3f-9f58-b4c345a5fe14"]);

export const getInfiniteResourceKey$GetSecondaryArtworkList =
  generateGetInfiniteResourceKey<Params>([
    "5e3a290f-ec14-4f3f-9f58-b4c345a5fe14",
  ]);
